/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { BillingCompanyIdentityResource } from './';
import {
    BillingCompanyIdentityResourceFromJSON,
    BillingCompanyIdentityResourceFromJSONTyped,
    BillingCompanyIdentityResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface CompanyIdentityDataResource
 */
export interface CompanyIdentityDataResource {
    /**
     * 
     * @type {BillingCompanyIdentityResource}
     * @memberof CompanyIdentityDataResource
     */
    assignedIdentity?: BillingCompanyIdentityResource;
    /**
     * 
     * @type {BillingCompanyIdentityResource}
     * @memberof CompanyIdentityDataResource
     */
    suggestedIdentity?: BillingCompanyIdentityResource;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyIdentityDataResource
     */
    identityIncoherence: boolean;
}

/**
 * Check if a given object implements the CompanyIdentityDataResource interface.
 */
export function instanceOfCompanyIdentityDataResource(value: object): value is CompanyIdentityDataResource {
    if (!('identityIncoherence' in value) || value['identityIncoherence'] === undefined) return false;
    return true;
}

export function CompanyIdentityDataResourceFromJSON(json: any): CompanyIdentityDataResource {
    return CompanyIdentityDataResourceFromJSONTyped(json, false);
}

export function CompanyIdentityDataResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyIdentityDataResource {
    if (json == null) {
        return json;
    }
    return {
        
        'assignedIdentity': json['assignedIdentity'] == null ? undefined : BillingCompanyIdentityResourceFromJSON(json['assignedIdentity']),
        'suggestedIdentity': json['suggestedIdentity'] == null ? undefined : BillingCompanyIdentityResourceFromJSON(json['suggestedIdentity']),
        'identityIncoherence': json['identityIncoherence'],
    };
}

export function CompanyIdentityDataResourceToJSON(value?: CompanyIdentityDataResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'assignedIdentity': BillingCompanyIdentityResourceToJSON(value['assignedIdentity']),
        'suggestedIdentity': BillingCompanyIdentityResourceToJSON(value['suggestedIdentity']),
        'identityIncoherence': value['identityIncoherence'],
    };
}

